import { render, staticRenderFns } from "./tablesub.vue?vue&type=template&id=8f004b92&scoped=true&"
import script from "./tablesub.vue?vue&type=script&lang=js&"
export * from "./tablesub.vue?vue&type=script&lang=js&"
import style0 from "./tablesub.vue?vue&type=style&index=0&id=8f004b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f004b92",
  null
  
)

export default component.exports